import { atom } from "jotai";
import { ApiCategory } from "src/api/types";
import useApi, { emptyApiState } from "src/hooks/api/utils/useApi";

const stateAtom: any = atom(emptyApiState);

type Options = {
	filter?: any;
};

function useCategories(options?: Options) {
	const { state, actions, api } = useApi(stateAtom, {
		baseUrl: `/categories`,
		query: {
			...(options?.filter || {}),
		},
	});
	const categories: ApiCategory[] = state?.list || [];

	return {
		categories,
		status: state.status,
		actions,
		api,
	};
}

export default useCategories;
